import { createUseStyles } from "react-jss";
import { breakpoints } from '../../../constants/breakpoints';
import { colors } from "constants/colors";

const styles = createUseStyles({
  removedTab: {

  },
  autocomplete:{
    [`@media (max-width: ${breakpoints.md}px)`]: {
      maxWidth: "none"
    },
  },
  filtersContainer: {
    display: "flex",
    margin: "32px 0 0 0",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      display: "grid",
    },
  },
  downloadLoadingState: {
    backgroundColor: `${colors.brightBlue} !important`,
    pointerEvents: "none",
    border: `1px solid ${colors.brightBlue}`,
    '& span': {
      borderColor: `${colors.darkerGrey} ${colors.darkerGrey} transparent !important`
    }
  },
  downloadRemovedPeopleBtn: {
    height: "fit-content",
    border: "none",
    alignSelf: "center",
    marginLeft: "auto",
    "& svg": {
      "& path": {
        stroke: colors.mediumGrey,
      },
    },
    "&:hover": {
      border: "none"
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: 0,
      paddingLeft: 0
    },
  },
  downloadRemovedPeopleDisabledBtn: {
    extend: "downloadTeamsBtn",
    "& svg": {
      "& path": {
        stroke: colors.darkGrey,
      },
    },
  }
});

export default styles;
